import { NgModule } from '@angular/core';
import { RootComponent } from './root.component';
import { RouterModule } from '@angular/router';
import {
  MatCardModule,
  MatButtonModule
} from '@angular/material';
import { FlexLayoutModule } from '@angular/flex-layout';
import { CommonModule } from '@angular/common';
import { DxLoadingModule } from '../loading/loading.module';

@NgModule({
  declarations: [ RootComponent ],
  exports:      [ RootComponent ],
  imports: [
    RouterModule,
    MatCardModule,
    FlexLayoutModule,
    MatButtonModule,
    CommonModule,
    DxLoadingModule
  ]
})
export class RootComponentModule {}
